let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("a2rZD")).then(() => parcelRequire('jH3CX'));